module.exports = __webpack_public_path__ + "img/bingo_ball-39.0e6aa005.png";